import template from './job-requests-filter.html';
import JobRequestsFilterController from './job-requests-filter.controller';
import './job-requests-filter.styl';

let jobRequestsFilterComponent = {
  restrict: 'E',
  bindings: {
    applyFilters: '&'
  },
  template,
  controller: JobRequestsFilterController,
  controllerAs: 'vm'
};

export default jobRequestsFilterComponent;



/** WEBPACK FOOTER **
 ** E:/JUGGLE_STREET/Juggle-Street-Deployment-All/JSBIGFOOTFRONTEND-BACKEND/admin-frontend/client/app/common/Components/job-requests-filter/job-requests-filter.component.js
 **/